// import i18n from "i18next";
import i18n from "@/i18n";

const START_WITH_LAST_NAME = ["hu-HU"];

export function getLanguageAwareName({ firstName, lastName }: { firstName: string, lastName: string }) {
  if (START_WITH_LAST_NAME.includes(i18n.language)) {
    return `${lastName} ${firstName}`;
  }
  return `${firstName} ${lastName}`;
}

export function getLocalizedField(fields: Record<string, any>, key: string, fallbackLanguage: string = 'en-US'): string {
  const localizedField = fields?.[key]?.[i18n.language];

  if (localizedField) {
    return localizedField.toString();
  }

  return fields?.[key]?.[fallbackLanguage]?.toString() || key;
}
